export enum CellVariantEnum {
  PATH = "PATH",
  OBSTACLE = "OBSTACLE",
  MAIN = "MAIN",
  OTHER = "OTHER",
}
